import FormControl from '@mui/material/FormControl';
import Stack from '@mui/material/Stack';
import { CheckboxField } from '@openx/components-core/lib/CheckboxField/CheckboxField.tsx';
import type { Option } from '@openx/types/options.ts';
import { type ChangeEvent, useCallback } from 'react';

type CheckboxSelectorProps = {
  selectedOptions: string[] | undefined;
  onOptionChange: (options: string | string[]) => void;
  isDisabled?: boolean;
  options?: Option[];
};

export const CheckboxSelector = ({ options, selectedOptions, onOptionChange, isDisabled }: CheckboxSelectorProps) => {
  const selectedItems = selectedOptions || [];

  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>, value: string) => {
      if (e.target.checked) {
        onOptionChange([...selectedItems, value]);
        return;
      }

      onOptionChange(selectedItems.filter(option => option !== value));
    },
    [selectedItems, onOptionChange]
  );

  return (
    <FormControl>
      <Stack
        spacing={1}
        sx={{
          alignItems: 'flex-start',
        }}
      >
        {options?.map(option => (
          <CheckboxField
            key={option.id}
            label={option.name}
            checked={selectedItems.includes(option.id)}
            onChange={e => handleChange(e, option.id)}
            disabled={isDisabled}
          />
        ))}
      </Stack>
    </FormControl>
  );
};
